/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Receipt_Print_FailedInputs */

const vi_receipt_print_failed = /** @type {(inputs: Receipt_Print_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không mở được cửa sổ in. Vui lòng thử lại.`)
};

/**

* @param {Receipt_Print_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const receipt_print_failed = /** @type {((inputs?: Receipt_Print_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_Print_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_receipt_print_failed(inputs)
});